module.exports = __webpack_public_path__ + "img/zfb.a5a353f6.png";